import { render } from "./AsrTimer.vue?vue&type=template&id=22138131"
import script from "./AsrTimer.vue?vue&type=script&lang=js"
export * from "./AsrTimer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__